var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"textOutputPanel",staticClass:"row ml-1 mb-2"},[_c('div',{staticClass:"text-center text-muted w-100 white-space-pre-line",attrs:{"data-testid":"suspend-text-output"},domProps:{"innerHTML":_vm._s(_vm.sanitizedMessage)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }